import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import User from '_class/User';
import { getUserInfo } from 'actions/user';
import { getVerdictScale, updateVerdict, deleteVerdict } from 'actions/verdicts';
import VerdictForm from 'containers/Verdict/Form/VerdictForm';
import VerdictDisplayFeedback from './Partials/VerdictDisplayFeedback';
import VerdictDisplayLevel from './Partials/VerdictDisplayLevel';
import { Button } from '@haldor/ui';

var VerdictDisplay = /*#__PURE__*/function (_Component) {
  _inherits(VerdictDisplay, _Component);

  var _super = _createSuper(VerdictDisplay);

  function VerdictDisplay(props) {
    var _this;

    _classCallCheck(this, VerdictDisplay);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.scale == null) {
        _this.props.getVerdictScale();
      }

      if (_this.getUser() == null) {
        _this.props.getUserInfo(_this.props.verdict.creator, 'base');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getUser", function () {
      var user = _this.props.users.find(function (user) {
        return user.userId == _this.props.verdict.creator;
      });

      return user;
    });

    _defineProperty(_assertThisInitialized(_this), "deleteVerdictPublished", function (verdict) {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('are-you-sure-you-want-to-delete'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('No'),
        confirmButtonText: _this.props.translate('Yes')
      }).then(function (result) {
        if (result.value != null) {
          if (_this.props.setLoading) {
            _this.props.setLoading(true);
          }

          _this.props.deleteVerdict(verdict.id).then(function () {
            if (_this.props.reload != null) {
              _this.props.reload();
            }
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deleteVerdictForm", function (verdict) {
      _this.setState({
        loading: true
      });

      if (_this.props.setLoading) {
        _this.props.setLoading(true);
      }

      _this.props.deleteVerdict(verdict.id).then(function () {
        if (_this.props.reload != null) {
          _this.props.reload();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onVerdictFormSubmit", function (values) {
      return new Promise(function (resolve) {
        values.courses = [{
          "courseCode": _this.props.course.courseCode,
          "subjectCode": _this.props.course.subjectCode,
          "courseID": _this.props.course.id
        }];

        _this.props.updateVerdict(values).then(function () {
          _this.setState({
            edit: false
          });

          if (_this.props.reload != null) {
            _this.props.reload();
          }

          resolve(1);
        });
      });
    });

    _this.state = {
      edit: false
    };
    return _this;
  }

  _createClass(VerdictDisplay, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.props.verdict == null) {
        return null;
      }

      var user = new User(this.props.currentUser);
      return /*#__PURE__*/React.createElement("div", {
        className: "verdict verdict-display-container"
      }, this.props.scale != null && !this.state.edit ? /*#__PURE__*/React.createElement(VerdictDisplayLevel, {
        verdict: this.props.verdict,
        scale: this.props.scale
      }) : null, /*#__PURE__*/React.createElement("div", {
        className: "display-feedback-container"
      }, !this.state.edit ? /*#__PURE__*/React.createElement(VerdictDisplayFeedback, {
        verdict: this.props.verdict,
        user: this.getUser()
      }) : null, this.state.edit ? /*#__PURE__*/React.createElement(VerdictForm, {
        verdict: this.props.verdict,
        deleteVerdict: this.deleteVerdictForm,
        onSubmit: this.onVerdictFormSubmit,
        edit: this.state.edit
      }) : null), !this.props.isStudent && (!this.props.group || !this.props.group.archived) ? /*#__PURE__*/React.createElement(Button, {
        style: {
          "float": 'right',
          marginTop: '1em'
        },
        type: "secondary",
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.setState({
            edit: _this2.state.edit ? false : true
          });
        }
      }, this.state.edit ? this.props.translate('close') : this.props.translate('Edit')) : null, !this.props.isStudent && (!this.props.group || !this.props.group.archived) && (user.isAdministrator() || user.data.id == this.props.verdict.creator) ? /*#__PURE__*/React.createElement(Button, {
        style: {
          "float": 'right',
          marginTop: '1em',
          marginRight: '0.5rem'
        },
        type: "secondary",
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.deleteVerdictPublished(_this2.props.verdict);
        }
      }, this.props.translate('Delete')) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }));
    }
  }]);

  return VerdictDisplay;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    scale: state.Verdicts.scale,
    currentUser: state.user.currentUser,
    users: state.user.info
  };
}

export default connect(mapStateToProps, {
  getVerdictScale: getVerdictScale,
  getUserInfo: getUserInfo,
  updateVerdict: updateVerdict,
  deleteVerdict: deleteVerdict
})(VerdictDisplay);